import { render, staticRenderFns } from "./TowerSettingsMinPrice.vue?vue&type=template&id=508d25f7"
import script from "./TowerSettingsMinPrice.vue?vue&type=script&lang=js"
export * from "./TowerSettingsMinPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports